function r() {
  return `cdr-id-${Math.floor((1 + Math.random()) * 16777216).toString(16).substring(1)}`;
}
export {
  r as default
};
